// App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth0 } from './auth/useAuth0';
import {UserProvider} from './auth/UserContext'; // Importa o contexto do usuário
import PrivateRoute from './auth/PrivateRoute';
import HomeComponent from './components/home/HomeComponent';
import AuthRedirect from './auth/AuthRedirect'; // Componente de redirecionamento
import ImpersonateEntry from './auth/ImpersonateEntry';
import ImpersonationBanner from './components/commons/impersonation/ImpersonationBanner';
import NotFoundComponent from './components/notfound/NotFoundComponent';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './design-system.css';
import {BusinessProvider} from "./context/BusinessContext";
import { PermissionsProvider } from "./context/PermissionsContext";
import { AlertProvider } from './context/alert/AlertContext';
import { NavigationProvider } from './context/NavigationContext';
import { PlanProvider } from './context/PlanContext';
import { ConfirmProvider } from './context/confirm/ConfirmContext';
import { ValueVisibilityProvider } from './context/ValueVisibilityContext';
import MessageComponent from './components/commons/message/MessageComponent';
import LanguageSync from './i18n/LanguageSync';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';

const App = () => {
    const { isAuthenticated, isLoading } = useAuth0();

    if (isLoading) {
        return <div>Loading application...</div>;
    }

    return (
        <QueryClientProvider client={queryClient}>
        <UserProvider> {/* Envolvendo a aplicação com UserProvider */}
            <BusinessProvider>
                <PermissionsProvider>
                <AlertProvider>
                    <ConfirmProvider>
                    <ValueVisibilityProvider>
                    <NavigationProvider>
                    <PlanProvider>
                    {/* Keeps the UI language synced with the business setting. */}
                    <LanguageSync />
                    {/* Single floating toast for the whole app. Reads from
                        AlertProvider and pins itself to the bottom-right.   */}
                    <MessageComponent />
                    {/* Visible only in an impersonation tab (ops console). */}
                    <ImpersonationBanner />
                    <Router basename={process.env.PUBLIC_URL || undefined}>
                        <Routes>
                            <Route path="/home" element={<PrivateRoute element={<HomeComponent />} />} />
                            <Route path="/auth-redirect" element={<AuthRedirect />} />
                            {/* Ops console entry: /impersonate#token=... (fragment, never sent to the server). */}
                            <Route path="/impersonate" element={<ImpersonateEntry />} />
                            <Route path="/404" element={<NotFoundComponent />} />
                            <Route
                                path="/"
                                element={isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/auth-redirect" />}
                            />
                            <Route path="*" element={<NotFoundComponent />} />
                        </Routes>
                    </Router>
                    </PlanProvider>
                    </NavigationProvider>
                    </ValueVisibilityProvider>
                    </ConfirmProvider>
                </AlertProvider>
                </PermissionsProvider>
            </BusinessProvider>
        </UserProvider>
        </QueryClientProvider>
    );
};

export default App;
